import { SECTION_SURVEYS } from '../../../api/endpoints';
import request from '../../../api/request';
import { StartSurveyData } from '../types';

/**
 *
 * @param sectionId
 * @returns
 */
export const getStartSurveyData = (sectionId: number | string) => {
  return request<StartSurveyData>(
    SECTION_SURVEYS.START_SURVEY_DATA(sectionId),
    {
      method: 'get',
    },
  );
};
